<template>
  <ul class="sidebar-nav lms-nav">
    <li class="nav-item show">
      <a
        @click="navhome()"
        class="nav-link"
        :class="{ active: 0 == $route.params.bid }"
        role="button"
      >
        <feather type="home"></feather>Тухай
      </a>
    </li>
    <li class="nav-item show" v-for="(b, i) in boxes" :key="i">
      <a
        @click="navopen(b)"
        class="nav-link"
        :class="{ 'with-sub': b.ot == 114, active: b.id == $route.params.bid }"
        role="button"
      >
        <feather :type="b.icon"></feather>
        <span class="text-uppercase">{{ b.nm }} </span>
        <!-- {{b.ot}} -->
        <!-- ({{b.tasks.length}},{{b.forms.length}},{{b.attaches.length}}) -->
      </a>
      <nav class="nav" v-if="b.tasks.length">
        <!-- <a @click="navopen(b)" role="button" :class="{'active': b.id==$route.params.bid && $route.params.iid==0 }">
              <span class="text-uppercase tx-12">Бүх {{b.nm}}</span>
          </a> -->
        <a
          @click="subNavOpen(b, t)"
          role="button"
          v-for="(t, i) in b.tasks"
          :key="i"
          :class="
            `d-flex flex-row align-items-center lh-3 tx-${getLessonIconColor(
              t
            )} ${t.id == $route.params.iid ? 'active' : ''}`
          "
        >
          <div class="mg-r-5 tx-13">{{ i + 1 }}.</div>
          <feather
            v-if="b.ot == 114"
            class="mg-r-5"
            :type="getLessonIcon(t)"
            :size="16"
            :stroke-width="1"
          ></feather>
          <div class="">{{ t.task }}</div>
          <!-- <span class="badge">15</span> -->
        </a>
      </nav>
      <nav class="nav" v-else-if="b.forms.length">
        <a
          @click="subNavOpen(b, f)"
          role="button"
          v-for="(f, i) in b.forms"
          :key="i"
          :class="{ active: f.id == $route.params.iid }"
        >
          <div>
            <span>{{ f.nm }}</span>
            <section v-if="f.flag == 700">
              <div class="progress ht-15">
                <div
                  role="progressbar"
                  :class="`progress-bar bg-${calcaulateProgressBg(f)}`"
                  :style="{ width: calcaulateProgress(f) + '%' }"
                >
                  <span class="tx-9"
                    >{{ calcaulateProgress(f).toFixed(2) }}%</span
                  >
                </div>
              </div>
              <div class="text-muted tx-12">
                {{ f.fillingCount }} / {{ f.qCount }}
              </div>
            </section>
            <div class="text-muted tx-12" v-else-if="f.flag == 900">
              {{ f.qCount }} асуулттай
            </div>
          </div>
        </a>
      </nav>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    active: {
      type: Object,
      default: () => {}
    },
    boxes: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    navhome() {
      this.$router.push({
        name: "lmsCourseView",
        params: {
          id: this.$route.params.id,
          bid: 0,
          iid: 0,
          bot: 0
        }
      });
    },
    navopen(box) {
      this.$router.push({
        name: "lmsCourseView",
        params: {
          id: this.$route.params.id,
          bid: box.id,
          iid: 0,
          bot: box.ot
        }
      });
      //this.$emit("sub-nav-change", {boxId: boxId, itemId: null } );
    },
    subNavOpen(box, t) {
      //&& this.lesson==undefined
      if (box.ot == 114) {
        //console.log('hicheel  rvv yavdaa');
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: t.id,
            cid: this.$route.params.id,
            bid: 0,
            iid: 0,
            bot: 0
          }
        });
      } else {
        this.$router.push({
          name: "lmsCourseView",
          params: {
            id: this.$route.params.id,
            bid: box.id,
            iid: t.id,
            bot: box.ot
          }
        });
      }
      //this.$emit("sub-nav-change", {boxId: box.id, itemId: t.id  } );
    },
    calcaulateProgress(f) {
      let rv = 0;
      rv = (f.fillingCount * 100) / f.qCount;
      return rv;
    },
    calcaulateProgressBg(f) {
      let rv = "secondary";
      let perc = (f.fillingCount * 100) / f.qCount;

      if (perc <= 9) {
        rv = "warning";
      } else if (perc <= 19) {
        rv = "gray-200";
      } else if (perc <= 29) {
        rv = "gray-300";
      } else if (perc <= 39) {
        rv = "gray-400";
      } else if (perc <= 49) {
        rv = "gray-500";
      } else if (perc <= 59) {
        rv = "gray-600";
      } else if (perc <= 69) {
        rv = "gray-700";
      } else if (perc <= 79) {
        rv = "gray-800";
      } else if (perc <= 89) {
        rv = "gray-900";
      } else if (perc <= 99) {
        rv = "gray-900";
      } else if (perc == 100) {
        rv = "success";
      }
      //console.log(perc, rv);
      return rv;
    },
    getLessonIcon(t) {
      let rv = "";
      if (t.im != null && t.im.isDone) {
        rv = "check-square";
      } else if (t.i == 1 && t.im == null) {
        rv = "lock";
      } else {
        return "square";
      }
      return rv;
    },
    getLessonIconColor(t) {
      let rv = "";
      if (t.im != null && t.im.isDone) {
        rv = "success";
      } else if (t.i == 1 && t.im == null) {
        rv = "muted";
      } else {
        return "black";
      }
      return rv;
    }
  }
};
</script>

<style></style>
